import React, { ReactNode } from "react";
import { connect }          from "react-redux";
import { Tab }              from "semantic-ui-react";
import MenuType             from "../../../domain/menu/MenuType";
import { ResKaState }       from "../../../index";
import Breadcrumbs          from "../../components/common/Breadcrunmbs";
import BackHistoryButton    from "../../components/common/BuckHistoryButton";
import RightPositionSection from "../../components/common/layout/RightPositionSection";
import TopSection           from "../../components/common/layout/TopSection";
import OfficeSelector       from "../../components/common/OfficeSelector";
import MailGroupList        from "../../components/setting/mail/group/MailGroupList";
import MailGroupRegisterFormButton
                            from "../../components/setting/mail/group/MailGroupRegisterFormButton";
import MailSettingFrom      from "../../components/setting/mail/setting/MailSettingForm";
import MailSettingUpdateButton
                            from "../../components/setting/mail/setting/MailSettingUpdateButton";
import MailTemplateList     from "../../components/setting/mail/template/MailTemplateList";
import MailTemplateRegisterFormButton
                                                    from "../../components/setting/mail/template/MailTemplateRegisterFormButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class MailSettingContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state: BaseState = {
      headerTitle: "メール配信設定",
      menuType: MenuType.SETTING,
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "メール配信設定",
                path: "/mail/setting"
              },
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>

        <TopSection>
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <Tab
          renderActiveOnly
          panes={ [
            {
              menuItem: "メール雛形",
              render: () => (
                <Tab.Pane>
                  <TopSection>
                    <MailTemplateRegisterFormButton/>
                  </TopSection>

                  <MailTemplateList/>
                </Tab.Pane>
              )
            },
            {
              menuItem: "メールグループ設定",
              render: () => (
                <Tab.Pane>
                  <TopSection>
                    <MailGroupRegisterFormButton/>
                  </TopSection>

                  <MailGroupList/>
                </Tab.Pane>
              )
            },
            {
              menuItem: "メール送信設定",
              render: () => (
                <Tab.Pane>
                  <TopSection>
                    <MailSettingUpdateButton/>
                  </TopSection>

                  <MailSettingFrom/>
                </Tab.Pane>
              )
            },
          ] }
        />
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(MailSettingContainer);